import axios from 'axios';
import { getValidToken } from './auth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.glainews.com/api";

// 401が返ったらトークンを削除（ページリロードで未ログイン状態になる）
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("accessToken");
    }
    return Promise.reject(error);
  }
);

export const fetchNewsDates = async () => {
  const response = await axios.get(`${API_BASE_URL}/news/dates`);
  return response.data;
};

export const fetchNews = async (page = 0, limit = 10, siteName = null, tag = null, date = null) => {
  try {
    const params = { page, limit };
    if (siteName && siteName !== "ALL") params.site_name = siteName;
    if (tag) params.tag = tag;
    if (date) params.date = date;

    const response = await axios.get(`${API_BASE_URL}/news`, { params });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error("fetchNews APIエラー: Unexpected response status", response);
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("fetchNews APIエラー:", error.response ? error.response.data : error.message);
    throw error;
  }
};

export const fetchNewsDetail = async (id) => {
  if (!id) {
    console.error("fetchNewsDetail に `undefined` または `null` の id が渡されました！");
    throw new Error("Invalid news ID");
  }

  try {
    console.log("送信する ID:", id);

    const response = await axios.post(
      `${API_BASE_URL}/news/detail`,
      { id },
      { headers: { "Content-Type": "application/json" } }
    );

    if (response.status === 200) {
      console.log("APIレスポンス:", response.data);
      return response.data;
    } else {
      console.error("fetchNewsDetail APIエラー: Unexpected response status", response);
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("fetchNewsDetail APIエラー:", error.response ? error.response.data : error.message);
    throw error;
  }
};

export const fetchRanking = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/ranking`);

    if (response.status === 200) {
      return response.data;
    } else {
      console.error("fetchRanking APIエラー: Unexpected response status", response);
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("fetchRanking APIエラー:", error.response ? error.response.data : error.message);
    throw error;
  }
};
// Login画面用
export const loginUser = async (email, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "ログインに失敗しました");
    }

    const data = await response.json();
    return data.access_token;  // JWT トークンを返す
  } catch (err) {
    throw err;
  }
};

// 保存済みニュースの取得
export const fetchSavedNewsIds = async () => {
  const token = getValidToken();
  if (!token) return [];

  try {
    const response = await axios.get(`${API_BASE_URL}/saved_news_ids`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
    });
    return response.data;
  } catch (err) {
    console.error("保存済みニュースの取得に失敗:", err);
    return [];
  }
};

// ニュース記事の保存
export const saveNews = async (news_id) => {
  const token = getValidToken();
  if (!token) return;

  try {
    await axios.post(
      `${API_BASE_URL}/save_news`,
      { news_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    console.error("ニュース保存に失敗:", err);
  }
};

// X投稿用: DeepSeekでポスト文生成 + X_POST_LOG insert（AIボタン用）
export const generateXPost = async (news_id, posted_by) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/x_post_generate`, { news_id, posted_by });
    return response.data;
  } catch (err) {
    console.error("X投稿生成に失敗:", err);
    return null;
  }
};

// X_POST_LOG から最新の投稿データを取得（Xボタン用）
export const fetchXPostData = async (news_id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/x_post_data`, { params: { news_id } });
    return response.data;
  } catch (err) {
    if (err.response?.status === 404) return null;
    console.error("X投稿データ取得に失敗:", err);
    return null;
  }
};

// ニュース記事の保存解除
export const unsaveNews = async (news_id) => {
  const token = getValidToken();
  if (!token) return;

  try {
    await axios.post(
      `${API_BASE_URL}/unsave_news`,
      { news_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    console.error("ニュース保存解除に失敗:", err);
  }
};